import { render, staticRenderFns } from "./ProjectInsight.vue?vue&type=template&id=0919fc90&scoped=true&lang=html&"
import script from "./ProjectInsight.vue?vue&type=script&lang=js&"
export * from "./ProjectInsight.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInsight.vue?vue&type=style&index=0&id=0919fc90&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0919fc90",
  null
  
)

export default component.exports